import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { carouselDotsSelector } from 'src/components/shared/SciPage/SciPage.selector';
import globalMessages from 'src/messages';

import { RedirectErrorRequest, ResolvedRedirectError } from './types';

const HOME_PATH = '/';
const DEFAULT_TEST_ID_KEY = 'default';

const DEFAULT_ERROR: Omit<ResolvedRedirectError, 'testIdKey'> = {
    title: globalMessages.errors.someThingWrong,
    description: globalMessages.errors.defaultErrorDescription,
    button: globalMessages.errors.defaultErrorButton,
    path: HOME_PATH,
};

export const useRedirectError = () => {
    const carouselDotsState = useSelector(carouselDotsSelector);
    const [redirectError, setRedirectError] =
        useState<ResolvedRedirectError | null>(null);

    const showDefault = useCallback(() => {
        setRedirectError({ ...DEFAULT_ERROR, testIdKey: DEFAULT_TEST_ID_KEY });
    }, []);

    const showForPage = useCallback(
        (request: RedirectErrorRequest) => {
            const targetItem = carouselDotsState?.items.find(
                (item) => item.pageEnum === request.targetPage,
            );

            if (!targetItem) {
                showDefault();
                return;
            }

            setRedirectError({
                title: request.title,
                description: request.description,
                button: request.button,
                path: targetItem.path,
                testIdKey: request.key,
            });
        },
        [carouselDotsState, showDefault],
    );

    const clear = useCallback(() => setRedirectError(null), []);

    return { redirectError, showForPage, showDefault, clear };
};
